import { draftClaimLineItemContext } from '~/app/features/crew/claim-line-items/claimLineItemMiddleware';
import { settingsContext } from '~/app/settingsMiddleware';
import { ClaimType } from '~/utils/constants';
import { isWarrantyClaimAllowedOutsideWindow } from '~/utils/order';
import { makeLoader, redirect } from '~/utils/routing';
import { claimTypeParamSchema } from '~/utils/schemas';
import { getClaimTypeProgramName } from '~/utils/theme';

const DEFAULT_DISCLAIMER =
  "It looks like this item's window has expired. We'd still like to help, please continue and we'll do our best to take care of you.";

export const { loader, useLoaderData } = makeLoader(({ context, params }) => {
  const { lineItem } = context.get(draftClaimLineItemContext);
  const settings = context.get(settingsContext);

  const claimType = claimTypeParamSchema.safeParse(params.claimType);

  if (
    claimType.data !== ClaimType.warranty ||
    !isWarrantyClaimAllowedOutsideWindow(lineItem)
  ) {
    return redirect('..');
  }

  const claimTypeProgramName = getClaimTypeProgramName(
    settings.theme,
    ClaimType.warranty,
  );
  const defaultTitle = `This item's ${claimTypeProgramName.toLocaleLowerCase()} window has closed`;

  return {
    outsideOfWarrantyDisclaimer:
      lineItem.warranty.ineligibleWarrantyClaimDisclaimer || DEFAULT_DISCLAIMER,
    outsideOfWarrantyTitle:
      lineItem.warranty.ineligibleWarrantyClaimTitle || defaultTitle,
  };
});
